import { useParams } from "react-router-dom";
import api from "../../../service/api";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Alert, Badge, Card, Col, Container, Row } from "react-bootstrap";

export const ViewEmailLog = () => {
    const { id } = useParams();
    const [email, setEmail] = useState();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();

    const fetchData = async () => {
        try {
            const response = await api.get(`tms/email-notification/${id}`);
            setEmail(response.data);
        } catch (error) {
            console.error(error);
            setError("Failed to fetch email log...");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [id]);

    const isSuccess = email?.status === 1;

    return (
        <>
            <Helmet title={email?.subject} />

            <Container fluid>
                <h3 className="mb-4">Email Log View</h3>
                {loading && <div>Loading...</div>}
                {error && <Alert variant="danger" className="p-2">{error}</Alert>}

                {!loading && !error && (
                    <>
                        <Card>
                            <Card.Header className="border  fw-bold">
                                Email Details
                            </Card.Header>

                            <Card.Body className="border">
                                <Row className="mb-2">
                                    <Col
                                        md={2}
                                        className="text-muted fw-semibold"
                                    >
                                        Module
                                    </Col>
                                    <Col md={10}>{email?.module}</Col>
                                </Row>

                                <Row className="mb-2">
                                    <Col
                                        md={2}
                                        className="text-muted fw-semibold"
                                    >
                                        From
                                    </Col>
                                    <Col md={10}>{email?.from_email}</Col>
                                </Row>

                                <Row className="mb-2">
                                    <Col
                                        md={2}
                                        className="text-muted fw-semibold"
                                    >
                                        To
                                    </Col>
                                    <Col md={10}>{email?.sent_to_email}</Col>
                                </Row>

                                <Row className="mb-2">
                                    <Col
                                        md={2}
                                        className="text-muted fw-semibold"
                                    >
                                        CC
                                    </Col>
                                    <Col md={10}>{email?.cc_email || "-"}</Col>
                                </Row>

                                <Row className="mb-2">
                                    <Col
                                        md={2}
                                        className="text-muted fw-semibold"
                                    >
                                        Subject
                                    </Col>
                                    <Col md={10}>{email?.subject}</Col>
                                </Row>

                                <Row className="mb-2">
                                    <Col
                                        md={2}
                                        className="text-muted fw-semibold"
                                    >
                                        Status
                                    </Col>
                                    <Col md={10}>
                                        <Badge
                                            bg={
                                                isSuccess ? "success" : "danger"
                                            }
                                        >
                                            {isSuccess ? "Success" : "Failed"}
                                        </Badge>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>

                        <Card className="mt-4">
                            <Card.Header className="border rounded fw-bold">
                                Email Content
                            </Card.Header>

                            <Card.Body
                                style={{
                                    border: "1px solid #eee",
                                    borderRadius: "6px",
                                    overflowX: "auto",
                                }}
                            >
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: email?.body,
                                    }}
                                />
                            </Card.Body>
                        </Card>
                    </>
                )}
            </Container>
        </>
    );
};
